module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-sm-center"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('form', {
    staticClass: "shaded",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.processForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.form.brand.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Company brand name\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.brand),
      expression: "form.brand"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Company brand name",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.form.brand)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "brand", $event.target.value)
      }, _vm.$v.form.brand.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.brand.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.brand.required) ? _c('span', [_vm._v("Company brand name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.brand.minLength) ? _c('span', [_vm._v("Your company brand must have at least 3 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-sm-6",
    class: {
      error: _vm.$v.form.name.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Your first and last name\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Please add your name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }, _vm.$v.form.name.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("First and last name are required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Your first and last name must have at least 4 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.positions) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('location-fields', {
    on: {
      "locationFieldsChanged": _vm.updateLocationFields
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.form.email.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Email\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.form.email),
      expression: "form.email",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    attrs: {
      "type": "email",
      "placeholder": "Your email"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "blur": [_vm.$v.form.email.$touch, function($event) {
        return _vm.$forceUpdate()
      }],
      "change": function($event) {
        _vm.$set(_vm.form, "email", $event.target.value.trim())
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.email.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.email.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.email.email) ? _c('span', [_vm._v("Must be a valid email")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.email.isUnique) ? _c('span', [_vm._v("This email is already in use.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.form.password.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Password\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.password),
      expression: "form.password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "Your password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value.trim())
      }, _vm.$v.form.password.$touch],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.form.password.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.password.required) ? _c('span', [_vm._v("Please type a password.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.password.minLength) ? _c('span', [_vm._v("Minimum length of 4 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller mt-2"
  }, [_c('checkbox', {
    staticClass: "d-inline",
    attrs: {
      "name": "terms",
      "value": "true"
    },
    model: {
      value: (_vm.form.hasAcceptTermsConditions),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasAcceptTermsConditions", $$v)
      },
      expression: "form.hasAcceptTermsConditions"
    }
  }), _vm._v("\n                I accept the\n\n                "), _c('span', {
    staticClass: "darker underlined pointer",
    on: {
      "click": _vm.openConditions
    }
  }, [_vm._v("Terms of Service and Privacy Policy")])], 1), _vm._v(" "), _c('input', {
    staticClass: "btn action widest full",
    attrs: {
      "type": "submit",
      "value": "Sign up free",
      "disabled": _vm.$v.form.$invalid
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-57323d00", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57323d00"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/supplier/Step1.vue
// module id = 1618
// module chunks = 0